import React from 'react';
import { Button } from '../../../components/ui/Button/Button';
import styles from './SubmitBar.module.scss';

interface SubmitBarProps {
  authorName: string;
  org: string;
  isSending?: boolean;
  onClear: () => void;
  onSubmit: () => void;
}

/** Липкая панель отправки: видно, от чьего имени уйдёт обращение. */
export function SubmitBar({ authorName, org, isSending = false, onClear, onSubmit }: SubmitBarProps) {
  return (
    <div className={styles.bar}>
      <div className={styles.note}>
        Обращение уйдёт от имени <b>{authorName}</b> · {org}
      </div>
      <div className={styles.actions}>
        <Button onClick={onClear}>Очистить форму</Button>
        <Button variant="primary" onClick={onSubmit}>
          Отправить обращение
        </Button>
      </div>
    </div>
  );
}
